import { noop } from 'lodash-es';
import React from 'react';
export const MobileFilterContext = React.createContext({
    closeDrawer: () => noop
});
